
(function () {
    'use strict';

    angular
        .module('setupApp')
        .factory('LibertyRoleGaService', LibertyRoleGaService);

    LibertyRoleGaService.$inject = ['$resource', 'authExpiredInterceptor', 'GLOBAL_URL'];

    function LibertyRoleGaService ($resource, authExpiredInterceptor, GLOBAL_URL) {
    	return $resource(GLOBAL_URL + 'api/ga/setup/libertyrolega/:uri',{uri: '@uri'}, {
  		  'postList':   {method:'POST', isArray: true},
//  		  'query': { method: 'GET', isArray: true},
  		  'post':   {method:'POST'},
  		  'save': {
  			method: 'POST',
  				transformRequest: formDataObject,
  				headers: { 'Content-Type' : undefined, enctype: 'multipart/form-data'}
  			},
  			'download': {
  	            method: 'POST',
  	            responseType: 'arraybuffer',
  	            transformResponse: [function (data,header) {
  	            	if(data.byteLength>0){
	  	            	var header = header();
	  	            	downLoad(data,header['file-type'],header['file-export']);
  	            	}
  	            }],
  			}
      });
    }
    /**
	 * DownLoad report
	 */
	function downLoad(response, type, fileName) {
			var file = new Blob([response], {type: type});
		  if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
	           window.navigator.msSaveBlob(file, fileName);
	       } else { // for other browsers
	    	   var fileURL = window.URL.createObjectURL(file);
	    	   // Test tren chorme va firefox
	    		 	var theAnchor = $('<a />')  
			        .attr('href', fileURL)  
			        .attr('download',fileName)
			         .appendTo('body');
 			    theAnchor[0].click();   
 			    theAnchor.remove();  
	    	   //var aTag = document.createElement("a");
	    	   	 //aTag.style.cssText = "display: none";
	    		/* aTag.style = "display: none";*/
	    		/* aTag.href = fileURL;
	    		 aTag.download = fileName;
	    		 aTag.click();*/
	       }
		
	};
	function formDataObject (data) {
        var fd = new FormData();
        angular.forEach(data, function(value, key) {
            fd.append(key, value);
        });
        return fd;
    }
})();

